import { render, staticRenderFns } from "./logisticsCompany.vue?vue&type=template&id=70b03bda&scoped=true&"
import script from "./logisticsCompany.vue?vue&type=script&lang=js&"
export * from "./logisticsCompany.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCompany.vue?vue&type=style&index=0&id=70b03bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b03bda",
  null
  
)

export default component.exports